import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";
import {
  SchemaResolver,
  CollectionResolver,
  DocResolver,
  APIResolver,
  eclipseAPIResolver,
} from "./resolvers/resolver";
import {
  AngularFireAuthGuard,
  redirectUnauthorizedTo,
} from "@angular/fire/compat/auth-guard";
const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(["/auth"]);

const routes: Routes = [
  {
    path: "",
    redirectTo: "dashboard",
    pathMatch: "full",
  },
  {
    path: "dashboard",
    canActivate: [AngularFireAuthGuard],
    data: {
      authGuardPipe: redirectUnauthorizedToLogin,
    },
    resolve: {
      data: CollectionResolver,
    },
    loadChildren: () =>
      import("./pages/dashboard/dashboard.module").then(
        (m) => m.DashboardPageModule,
      ),
  },
  {
    path: "auth",
    loadChildren: () =>
      import("./pages/auth/auth.module").then((m) => m.AuthPageModule),
  },
  {
    path: "tools/apiPlayground",
    resolve: {
      // data: eclipseAPIResolver,
    },
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
    loadChildren: () =>
      import("./tools/apiPlayground/apiPlayground.module").then(
        (m) => m.PlaygroundPageModule,
      ),
  },
  {
    path: "tools/webPlayground",
    resolve: {
      data: APIResolver,
    },
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
    loadChildren: () =>
      import("./tools/webPlayground/playground.module").then(
        (m) => m.PlaygroundPageModule,
      ),
  },
  {
    path: "tools/processes",
    resolve: {
      data: CollectionResolver,
    },
    canActivate: [AngularFireAuthGuard],
    data: {
      authGuardPipe: redirectUnauthorizedToLogin,
      collection: "processes_",
    },
    loadChildren: () =>
      import("./tools/processes/processes.module").then(
        (m) => m.ProcessesPageModule,
      ),
  },
  {
    path: "tools/processes/:id",
    resolve: {
      collections: CollectionResolver,
      //apis: APIResolver
    },
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
    loadChildren: () =>
      import("./tools/builder/builder.module").then((m) => m.BuilderPageModule),
  },
  {
    path: "tools/hotJar",
    resolve: {
      // collections: CollectionResolver,
      //apis: APIResolver
    },
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
    loadChildren: () =>
      import("./tools/hotjar/hotjar.module").then((m) => m.HotJarPageModule),
  },
  {
    path: "tools/expenseReport",
    resolve: {
      // collections: CollectionResolver,
      //apis: APIResolver
    },
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
    loadChildren: () =>
      import("./tools/expenseReport/er.module").then(
        (m) => m.ExpenseReportPageModule,
      ),
  },
  {
    path: "tools/productEnrichment",
    resolve: {
      // collections: CollectionResolver,
      //apis: APIResolver
    },
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
    loadChildren: () =>
      import("./tools/productEnrichment/productEnrichment.module").then(
        (m) => m.ProductEnrichmentPageModule,
      ),
  },
  {
    path: "schemas_/:schema",
    resolve: {
      data: SchemaResolver,
    },
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
    loadChildren: () =>
      import("./pages/schema/schema.module").then((m) => m.SchemaPageModule),
  },
  {
    path: ":collection",
    resolve: {
      data: CollectionResolver,
    },
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
    loadChildren: () =>
      import("./pages/collections/collections.module").then(
        (m) => m.CollectionsPageModule,
      ),
  },
  {
    path: ":collection/:doc",
    resolve: {
      data: DocResolver,
    },
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
    loadChildren: () =>
      import("./pages/doc/doc.module").then((m) => m.DocPageModule),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
